type ColorFieldProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
};

function normalizeHex(raw: string): string {
  const t = raw.trim();
  if (!t) return '';
  const withHash = t.startsWith('#') ? t : `#${t}`;
  if (/^#[0-9a-fA-F]{6}$/.test(withHash)) return withHash.toLowerCase();
  if (/^#[0-9a-fA-F]{3}$/.test(withHash)) {
    const [, a, b, c] = withHash;
    return `#${a}${a}${b}${b}${c}${c}`.toLowerCase();
  }
  return withHash;
}

/** Native color picker + hex text; empty means “use default”. */
export function ColorField({ label, value, onChange, placeholder = '#000000' }: ColorFieldProps) {
  const pickerValue = normalizeHex(value) || '#000000';
  const hasValue = Boolean(value.trim());

  return (
    <div>
      <label className="block text-sm font-medium text-slate-700 mb-1">{label}</label>
      <div className="flex items-center gap-2">
        <input
          type="color"
          aria-label={label}
          value={pickerValue}
          onChange={(e) => onChange(e.target.value)}
          className="h-10 w-12 cursor-pointer rounded-lg border border-slate-300 bg-white p-1"
        />
        <input
          type="text"
          dir="ltr"
          className="flex-1 rounded-lg border border-slate-300 px-3 py-2 text-sm font-mono focus:outline-none focus:ring-2 focus:ring-indigo-500"
          value={value}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
          onBlur={() => {
            if (!value.trim()) return;
            onChange(normalizeHex(value));
          }}
        />
        {hasValue ? (
          <button
            type="button"
            onClick={() => onChange('')}
            className="rounded-lg border border-slate-200 px-2.5 py-2 text-xs text-slate-600 hover:bg-slate-50"
          >
            پاک
          </button>
        ) : null}
      </div>
    </div>
  );
}
